const mapping: Record<string, string> = {
  id: 'e=>e.Id',
  name: 'e=>e.Name',
}

export const mapSortFileParam = (key: string) => mapping[key]
